import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import Modal from 'components/Modal';
import styled from 'styled-components';
import LeftTimeTracker from './LeftTimeTracker';
import RightTimeTracker from './RightTimeTracker';
import { Form } from 'antd';
import dayjs from 'dayjs';

export type TimeTrackerModalRef = {
  open: () => void;
  close: () => void;
};

type Props = {};

const TimeTrackerModal = forwardRef<TimeTrackerModalRef, Props>((props, ref) => {
  const [form] = Form.useForm();
  const [isOpen, setIsOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    open: () => setIsOpen(true),
    close: () => setIsOpen(false),
  }));

  const handleClose = () => {
    setIsOpen(false);
    form.setFieldsValue({
      staffId: '',
      date: null,
    });
  };

  useEffect(() => {
    if (isOpen) {
      form.setFieldsValue({
        staffId: '',
        date: dayjs(),
      });
    }
  }, [isOpen]);

  return (
    <Modal
      hiddenOkButton={true}
      visible={isOpen}
      onClose={handleClose}
      width={'80vw'}
      v2
      modalTitle='Time Tracker'
      noneBodyStyle={true}
    >
      <Form layout='vertical' form={form}>
        <Container>
          <LeftTimeTracker />
          <RightTimeTracker />
        </Container>
      </Form>
    </Modal>
  );
});

TimeTrackerModal.displayName = 'TimeTrackerModal';
export default TimeTrackerModal;

const Container = styled.div`
  background: #fff;
  display: flex;
  padding-bottom: 0.25rem;
`;
